import { InjectionToken } from '@angular/core';
import { GATag } from '../models/ga-tag.type';

export const GA_GLOBAL_DATA = new InjectionToken<GATag>('GA Global Data');
